import React from 'react';

type Variant = 'primary' | 'secondary' | 'ghost' | 'danger';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  loading?: boolean;
  fullWidth?: boolean;
}

export const Button: React.FC<Props> = ({
  variant = 'primary',
  loading,
  fullWidth,
  disabled,
  children,
  style,
  ...rest
}) => {
  const palette = paletteFor(variant);
  const isDisabled = disabled || loading;

  return (
    <button
      {...rest}
      disabled={isDisabled}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
        padding: '10px 18px',
        height: 42,
        borderRadius: 'var(--radius-md)',
        fontWeight: 600,
        fontSize: 14,
        background: palette.bg,
        color: palette.fg,
        border: palette.border,
        opacity: isDisabled ? 0.6 : 1,
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        transition: 'background 120ms ease',
        width: fullWidth ? '100%' : undefined,
        ...style,
      }}
    >
      {loading ? 'Please wait…' : children}
    </button>
  );
};

function paletteFor(variant: Variant): {
  bg: string;
  fg: string;
  border: string;
} {
  switch (variant) {
    case 'primary':
      return {
        bg: 'var(--primary)',
        fg: 'var(--text-inverse)',
        border: '1px solid var(--primary)',
      };
    case 'secondary':
      return {
        bg: 'var(--bg-card)',
        fg: 'var(--text-primary)',
        border: '1px solid var(--border)',
      };
    case 'ghost':
      return {
        bg: 'transparent',
        fg: 'var(--text-secondary)',
        border: '1px solid transparent',
      };
    case 'danger':
      return {
        bg: 'var(--error)',
        fg: 'var(--text-inverse)',
        border: '1px solid var(--error)',
      };
  }
}
